
import { supabase } from '../../supabase';

export interface DeviationLog {
    type: 'strategy_ignore' | 'manual_adjustment';
    reason: string;
    dispatcherId?: string; // Could be email or ID from auth
    timestamp: number;
    orderIds: string[];
    strategyName?: string; // For ignored strategies
    adjustmentType?: 'own' | 'third'; // For manual adjustments
    storeId?: string;
}

export const logDeviation = async (
    deviation: Omit<DeviationLog, 'timestamp'>,
    userProfile?: any
) => {
    try {
        const logEntry: DeviationLog = {
            ...deviation,
            timestamp: Date.now(),
            dispatcherId: userProfile?.email || 'unknown_dispatcher'
        };

        if (!logEntry.storeId) throw new Error('Missing storeId for deviation log.');
        await supabase.from('sal_deviations').insert({
            store_id: logEntry.storeId,
            type: logEntry.type,
            reason: logEntry.reason,
            order_ids: logEntry.orderIds,
            strategy_name: logEntry.strategyName,
            adjustment_type: logEntry.adjustmentType,
            dispatcher_id: logEntry.dispatcherId,
            created_at: new Date(logEntry.timestamp).toISOString()
        });

        // Logged to Supabase
    } catch (e) {
        console.error("Failed to log deviation:", e);
    }
};

export const fetchDeviations = async (storeId: string): Promise<DeviationLog[]> => {
    try {
        const { data, error } = await supabase
            .from('sal_deviations')
            .select('*')
            .eq('store_id', storeId)
            .order('created_at', { ascending: false });
        if (error || !data) return [];
        return data.map((row: any) => ({
            type: row.type,
            reason: row.reason,
            dispatcherId: row.dispatcher_id,
            timestamp: row.created_at ? new Date(row.created_at).getTime() : Date.now(),
            orderIds: row.order_ids || [],
            strategyName: row.strategy_name,
            adjustmentType: row.adjustment_type,
            storeId: row.store_id
        }));
    } catch (e) {
        console.error("Failed to fetch deviations:", e);
        return [];
    }
};
